import { UserRoleActions } from '../types';
import { Injector, runInInjectionContext } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { ROLES_ACTION } from '../actions';

export function handleUserRoleActions(
  userRoleAction: UserRoleActions,
  previousPageUrl: string,
  injector: Injector,
): void {
  runInInjectionContext(injector, () => {
    const _router = injector.get(Router);
    const _store = injector.get(Store);

    switch (userRoleAction.actionMode) {
      case 'edit':
        _router.navigateByUrl(
          `/admin/create-user-roles?editMode=true&roleId=${userRoleAction.role?.id}&previousPageUrl=${previousPageUrl}`,
          {
            state: {
              runGuardsAndResolvers: 'paramsChange',
            },
          },
        );
        break;
      case 'delete':
        _store.dispatch(
          ROLES_ACTION.checkRoleDeleteEligibility({
            role: userRoleAction.role,
          }),
        );
        break;
    }
  });
}
